import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import es from './es.json';

// Get default language from environment or localStorage
const DEFAULT_LANG = import.meta.env.VITE_DEFAULT_LANG || 'es';
const savedLang = localStorage.getItem('language') || DEFAULT_LANG;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    lng: savedLang,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
